/**
 * Promote deferred second-angle / hover images on product cards.
 * Images render with data-src / data-srcset until pointerenter or focusin.
 */
const DEFERRED_SELECTOR =
  'img.product-media__image--deferred, img.product-media__image--deferred-hover';
const CARD_SELECTOR = '.card-gallery, product-card, .product-card';

/**
 * @param {ParentNode} root
 */
function promoteDeferred(root) {
  root.querySelectorAll(DEFERRED_SELECTOR).forEach((img) => {
    if (!(img instanceof HTMLImageElement)) return;
    const srcset = img.getAttribute('data-srcset');
    const src = img.getAttribute('data-src');
    const sizes = img.getAttribute('data-sizes');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }
    if (sizes) {
      img.setAttribute('sizes', sizes);
      img.removeAttribute('data-sizes');
    }
    img.classList.remove('product-media__image--deferred', 'product-media__image--deferred-hover');
  });
}

/**
 * @param {Element} card
 */
function bindCard(card) {
  if (!(card instanceof Element)) return;
  if (card.dataset.hoverMediaBound === '1') return;
  if (!card.querySelector(DEFERRED_SELECTOR)) return;
  card.dataset.hoverMediaBound = '1';

  const promote = () => promoteDeferred(card);
  card.addEventListener('pointerenter', promote, { once: true });
  card.addEventListener('focusin', promote, { once: true });
}

/**
 * @param {ParentNode} [root]
 */
function scan(root = document) {
  root.querySelectorAll(CARD_SELECTOR).forEach(bindCard);
}

scan();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches(CARD_SELECTOR)) bindCard(node);
      else scan(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
